<!--
  @author xiehan
  @description 数据查询 配置页
  @date 2018/11/27
-->
<template>
  <div class="handlerSearchConfig__content">
    <g-back :history="history" class="ilb mr-base"></g-back>
    <el-button type="primary"
      @click="saveConfig"
      v-g-rac="gRac('handlerSearchConfig@save')" 
      v-text="$t('common.save')"></el-button>
    <el-form 
      ref="handlerForm" 
      :model="handlerForm" 
      label-width="80px" 
      input-width="180px" 
      :rules="handlerRules">
      <el-form-item :label="$t('dataSearch.dataName')" prop="name">
        <el-input v-model="handlerForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dataSearch.dataSource')" prop="source" input-width="auto">
        <span v-text="handlerForm.source" class="choose-btn" @click="dialogVisible = true"></span>
      </el-form-item>
      <el-form-item :label="$t('dataSearch.rule')" prop="rule" input-width="auto">
        <el-form :inline="true">
          <el-form-item>
            <el-select v-model="handlerForm.rule">
              <el-option
                v-for="item in select_rule"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="sort">{{ $t('dataSearch.reverse') }}</el-checkbox>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item :label="$t('dataSearch.viewConfig')" input-width="auto">
        <table class="t-table" v-if="configList.length > 0">
          <thead>
            <tr>
              <th class="t-border" v-text="$t('dataSearch.property')"></th>
              <th class="t-border" v-text="$t('dataSearch.name')"></th>
              <th class="t-border" v-text="$t('dataSearch.databaseType')"></th>
              <th class="t-border" v-text="$t('dataSearch.isShow')"></th>
              <th class="t-border" v-text="$t('dataSearch.isSearch')"></th>
              <th class="t-border" v-text="$t('dataSearch.isVague')"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in configList" :key="item.property">
              <td class="t-border" v-text="item.property" :title="item.property"></td>
              <td class="t-border" v-text="item.name" :title="item.propertyName"></td>
              <td class="t-border">{{ item.valueType | typeDic(select_valueType) }}</td>
              <td class="t-border">
                <el-checkbox v-model="item.show">{{ $t('dataSearch.yes') }}</el-checkbox>
              </td>
              <td class="t-border">
                <el-checkbox v-model="item.search">{{ $t('dataSearch.yes') }}</el-checkbox>
              </td>
              <td class="t-border">
                <el-checkbox v-model="item.vague">{{ $t('dataSearch.yes') }}</el-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
        <label v-text="$t('common.noData')" class="el-form-item__label" v-else></label>
      </el-form-item>
    </el-form>
    <el-dialog :closeOnClickModal="false" 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="800px">
      <el-form :inline="true" input-width="auto">
        <el-form-item>
          <el-input v-model="searchDialogInput" v-show="dialogStep !== 3"></el-input>
          <el-select v-model="searchDialogSelect" v-show="dialogStep === 3">
            <el-option
              v-for="item in select_resourceType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="searchDialogTable(true)"
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tableData"
        :head="tableHead"
        :currentChange="currentChange"
        :sizeChange="sizeChange"
        highlight-current-row
        :rowClick="tableClick"
        border>
      </el-table-extend>
      <div slot="footer">
        <el-button @click="dialogVisible = false" v-text="$t('common.cancel')"></el-button>
        <el-button 
          type="primary"
          v-text="$t('dataSearch.back')"
          @click="back"
          v-show="dialogStep > 1"></el-button>
        <el-button 
          type="primary"
          v-text="$t('dataSearch.next')"
          @click="next"
          v-show="dialogStep < 3"></el-button>
        <el-button 
          type="primary"
          v-text="$t('common.confirm')"
          @click="confirmChoose"
          v-show="dialogStep === 3"></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import dataDictionaryBiz from '@/logic/cmdb/dataDictionaryBiz'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import dataSearchBiz from '@/logic/logRetrieve/dataSearchBiz'
  export default {
    mixins: [rac, dic],
    data () {
      let checkSource = (rule, value, callback) => {
        if (!value || value === this.$t('common.chooseTips')) {
          return callback(new Error(this.$t('common.chooseTips') + this.$t('dataSearch.dataSource')))
        } else {
          callback()
        }
      }
      return {
        history: [],
        select_dbType: {},
        select_resourceType: {},
        select_rule: [],
        select_valueType: {},
        handlerForm: {
          name: '',
          source: this.$t('common.chooseTips'),
          rule: ''
        },
        sort: false,
        handlerRules: {
          name: [
            { required: true, message: this.$t('dataSearch.dataNameTips'), trigger: 'blur' }
          ],
          source: [
            { required: true, validator: checkSource, trigger: 'blur' }
          ]
        },
        dialogTitle: '',
        dialogVisible: false,
        dialogStep: 0,
        tableData: {},
        tableHead: [],
        currentPage: 1,
        perPageCount: 10,
        clickDatabaseObj: null,
        clickTableObj: null,
        clickInstanceObj: null,
        searchDialogInput: '',
        searchDialogSelect: '',
        configList: [],
        dialogSaveInfo: {
          database: '',
          databaseType: '',
          table: '',
          instanceId: '',
          flagId: ''
        }
      }
    },
    methods: {
      async waitDBType () {
        await this.dGetDictionaryByCode('databaseType')
        this.select_dbType = { ...this.dDictionary.databaseType }
        this.getDatabaseData()
        this.setDataBaseHead()
      },
      async valueType () {
        await this.dGetDictionaryByCode('valueType')
        this.select_valueType = { ...this.dDictionary.valueType }
        if (this.$route.query.id) this.getQueryCondition()
      },
      setHistory () {
        this.history = []
        this.history.push({ name: this.$route.query.id
          ? this.$t('dataSearch.editSearchConfig') : this.$t('dataSearch.addSearchConfig') })
      },
      getQueryCondition () {
        dataSearchBiz.queryConditionById({ id: this.$route.query.id }).then(data => {
          this.configList = data.property
          this.dialogSaveInfo.database = data.database
          this.dialogSaveInfo.databaseType = data.databaseType
          this.dialogSaveInfo.table = data.table
          this.dialogSaveInfo.instanceId = data.instanceId
          this.dialogSaveInfo.flagId = data.flagId
          this.setRuleSelect(data.property)
          this.handlerForm.name = data.name
          this.handlerForm.source = `${data.database}、${
            data.table}、${data.instanceId}`
          this.handlerForm.rule = data.rule
          this.sort = data.sort
        })
      },
      getResourceType () {
        resourceModelBiz.getResource().then(data => {
          let selectList = []
          let arr = data.filter(item => item.resourceType === '3')
          arr.map(item => {
            selectList.push({
              value: item.flagId,
              label: item.resourceName
            })
          })
          this.select_resourceType = selectList
        })
      },
      saveConfig () {
        this.$refs['handlerForm'].validate((valid) => {
          if (valid) {
            let saveObj = {
              name: this.handlerForm.name,
              rule: this.handlerForm.rule,
              sort: this.sort,
              property: this.configList,
              ...this.dialogSaveInfo
            }
            if (this.$route.query.id) {
              saveObj.id = this.$route.query.id
              dataSearchBiz.updateCondition(saveObj).then(data => {
                this.successMessage()
                this.$router.push({ name: 'dataSearchCheck', query: { id: this.$route.query.id } })
              })
            } else {
              dataSearchBiz.saveCondition(saveObj).then(data => {
                this.successMessage()
                this.$router.push({ name: 'dataSearch' })
              })
            }
          } else {
            return false
          }
        })
      },
      back () {
        this.dialogStep--
      },
      next () {
        if (this.dialogStep === 1 && !this.clickDatabaseObj) {
          this.warningTips(this.$t('dataSearch.databaseAlert'))
          return
        } else if (this.dialogStep === 2 && !this.clickTableObj) {
          this.warningTips(this.$t('dataSearch.tableAlert'))
          return
        }
        this.dialogStep++
      },
      searchDialogTable (init = false) {
        if (init) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        switch (this.dialogStep) {
          case 1:
            this.clickDatabaseObj = null
            this.dialogTitle = this.$t('dataSearch.chooseDataBase')
            this.waitDBType()
            break
          case 2:
            this.clickTableObj = null
            this.dialogTitle = `${this.clickDatabaseObj.name}-${this.$t('dataSearch.chooseTable')}`
            this.getDataTableData()
            this.setDataTableHead()
            break
          case 3:
            this.clickInstanceObj = null
            this.dialogTitle = `${this.clickDatabaseObj.name}-
              ${this.clickTableObj.tableName}-${this.$t('dataSearch.chooseInstance')}`
            this.getInstanceTableData()
            this.setInstanceTableHead()
            break
        }
      },
      tableClick (row) {
        switch (this.dialogStep) {
          case 1:
            let obj = {}
            for (let i in row) {
              obj[i] = row[i]
            }
            this.clickDatabaseObj = obj
            this.clickDatabaseObj.databaseType = Object.keys(this.select_dbType)
              .filter(item => this.select_dbType[item] === this.clickDatabaseObj.databaseType)[0]
            break
          case 2:
            this.clickTableObj = row
            break
          case 3:
            this.clickInstanceObj = row
            break
        }
      },
      confirmChoose () {
        if (!this.clickInstanceObj) {
          this.warningTips(this.$t('dataSearch.instanceAlert'))
          return
        }
        this.configList = []
        this.getViewConfigData().then(data => {
          this.setDialogInfo()
          this.setRuleSelect(data)
          this.setConfigList(data)
          this.dialogVisible = false
          this.handlerForm.source = `${this.clickDatabaseObj.name}、${
            this.clickTableObj.tableName}、${this.clickInstanceObj.instanceId}`
        })
      },
      setDialogInfo () {
        this.dialogSaveInfo.database = this.clickDatabaseObj.name
        this.dialogSaveInfo.databaseType = this.clickDatabaseObj.databaseType
        this.dialogSaveInfo.table = this.clickTableObj.tableName
        this.dialogSaveInfo.instanceId = this.clickInstanceObj.instanceId
        this.dialogSaveInfo.flagId = this.clickInstanceObj.flagId
      },
      setRuleSelect (data) {
        let arr = []
        data.map(item => {
          arr.push({ value: item.property, label: item.property })
        })
        this.select_rule = arr
        this.handlerForm.rule = this.select_rule[0].value
      },
      setConfigList (data) {
        let arr = []
        data.map(item => {
          arr.push({
            property: item.property,
            name: item.propertyName,
            valueType: item.type,
            show: false,
            search: false,
            vague: false
          })
        })
        this.configList = arr
      },
      currentChange (val) {
        this.currentPage = val
        this.searchDialogTable()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.searchDialogTable()
      },
      getDatabaseData () {
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        if (this.searchDialogInput) searchObj['name'] = this.searchDialogInput
        dataDictionaryBiz.getDic(searchObj).then(data => {
          this.tableData = data
        })
      },
      setDataBaseHead () {
        this.tableHead = [
          { key: 'name', label: this.$t('dataSearch.databaseTable.name') },
          { key: 'databaseType',
            label: this.$t('dataSearch.databaseTable.databaseType'),
            formatter: 'Dictionary',
            formatterDic: this.select_dbType },
          { key: 'desc', label: this.$t('dataSearch.databaseTable.desc') }
        ]
      },
      getDataTableData () {
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount,
          parentId: this.clickDatabaseObj.id
        }
        if (this.searchDialogInput) searchObj['tableName'] = this.searchDialogInput
        dataDictionaryBiz.getTable(searchObj).then(data => {
          this.tableData = data
        })
      },
      setDataTableHead () {
        this.tableHead = [
          { key: 'tableName', label: this.$t('dataSearch.dataTable.tableName') },
          { key: 'tableDesc', label: this.$t('dataSearch.dataTable.tableDesc') }
        ]
      },
      getInstanceTableData () {
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount,
          flagId: this.searchDialogSelect
        }
        resourceModelBiz.getInstanceByTable(searchObj).then(data => {
          this.tableData = data
        })
      },
      setInstanceTableHead () {
        this.tableHead = [
          { key: 'instanceId', label: this.$t('dataSearch.instanceTable.instanceId') },
          { key: 'desc', label: this.$t('dataSearch.instanceTable.desc') }
        ]
      },
      getViewConfigData () {
        return new Promise((resolve) => {
          dataDictionaryBiz.getTableProperty({ id: this.clickTableObj.id }).then(data => {
            resolve(data)
          })
        })
      },
      warningTips (tips) {
        this.$message({
          message: tips,
          type: 'warning'
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      resetForm () {
        this.handlerForm.name = ''
        this.handlerForm.source = this.$t('common.chooseTips')
        this.handlerForm.rule = ''
        this.sort = false
        this.configList = []
        this.select_rule = []
        this.$refs.handlerForm.clearValidate()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerSearchConfig' && (from.name === 'dataSearch' || from.name === 'dataSearchCheck')) {
          this.setHistory()
          this.valueType()
          if (!to.query.id) this.resetForm()
        }
      },
      dialogVisible (val) {
        if (val) {
          this.dialogStep = 1
        } else {
          this.dialogStep = 0
        }
      },
      dialogStep (val) {
        this.searchDialogInput = ''
        this.searchDialogSelect = this.select_resourceType[0].value
        this.searchDialogTable(true)
      }
    },
    filters: {
      typeDic (value, select) {
        return select[value]
      }
    },
    mounted () {
      this.valueType()
      this.getResourceType()
      this.setHistory()
    }
  }
</script>

<style scoped>
  .choose-btn {
    color: #3385ff;
    cursor: pointer;
  }
  .t-table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .t-border {
    width: 110px;
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    text-align: center;
    font-weight: normal;
    border: 1px solid #ddd;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>